import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import NavbarComponent from './Components/Navbar/Navbar'; // Main Navbar
import MoveNavbar from './Components/Navbar/MoveNavbar'; // Separate Navbar for specific pages
import HomePage from './Components/Home Page/HomePage';

import SellYourVehicleForm from './Components/CarSale/CarSale';
import CarList from './Components/Carlist/CarList';
import CarDetails from './Components/Carlist/CarDetails';
import Footer from './Components/Footer/Footer'; // Default Footer
import MoveFooter from './Components/Footer/MoveFooter'; // Conditional Footer
import ScrollToTop from './Components/ScrollToTop';
import SignUpForm from './Components/Admin/Admin';
import AdminPortal from './Components/Admin/AdminPortal';
import ContactUS from './Components/ContactUs/ContactUs';
import { CarFilterProvider } from './Components/Carlist/FilterContext';
import ContactFormMovex from './Components/Move/SubContractForm/ContactFromMovex';
import { HelmetProvider } from "react-helmet-async";

import MoveHomePage from './Components/Move/MoveHomePage/MoveHomePage';
import Services from './Components/Move/MoveServices';
import AdminNavbar from './Components/Navbar/AdminNavbar';
import AdminFooter from './Components/Footer/AdminFooter';
import AddMakeForm from './Components/Admin/AddmakeForm';
import AchievementForm from './Components/Admin/Achievements';
import DeleteWhyUsCards from './Components/Admin/DeleteWhyus';
import AdminAdd from './Components/Admin/AddAdmin';
import ServiceForm from './Components/Admin/MoveFeatures';
import WhyusForm from './Components/Admin/Why US form';
import WinterStatus from './Components/Admin/Winteredit';
import AddModelAndVariant from './Components/Admin/AddModelvariant';
import LogosForm from './Components/Admin/Logosupload';
import DelCarList from './Components/Carlist/Carlistadmins';
import CarEditForm from './Components/CarSale/Caredit';
import { AddressProvider } from './Components/Move/AddressContext';

import Timing from './Components/Move/Timing';
import ProtectedRoute from './ProtectedRoute';
import UserInformationForm from './Components/Move/DriverDetail';
import MoveContactUs from './Components/ContactUs/MoveContactUs';
import SignupPage from './Components/Transport Account/SignupForm';
import TermsAndConditionspage from './Components/Move/MoveHomePage/TermsAndConditions.';
import CarListReview from './Components/Carlist/CarListReview';
import ListYourVehicleForm from './Components/CarSale/CarSaleAdmin';
import DeleteReview from './Components/Reviews/DeleteReviews';
import CarDetailsAdmin from './Components/Carlist/CarDetailsAdmin';
import AboutUsAdmin from './Components/Admin/AboutUs';
import GoogleLocationManager from './Components/Admin/Location';
import ContactEditor from './Components/Admin/Contactnumber';
import EmailManager from './Components/Admin/Email';
import { AdminProvider } from './Components/Admin/AdminContext';
import LoginPage from './Components/Transport Account/Dealer';
import LogisticsHomepage from './Components/Transport Account/Logistics Homepage';
import { DealerProvider, DealerAdmin } from "./Components/Transport Account/DealerProvider";
import RegisteredContactFormMovex from './Components/Move/SubContractFormRegistered/ContactFromMovex';
import DealerProtectedRoute from './ProtectedRoute Dealer';
import TransportProtectedRoute from './ProtectedRoute Dealer copy';
import RecordList from './Components/Move/SubContractFormRegistered/Recordlist';
import { TransportAdminProvider } from './Components/Transport Admin/TransportAdminContext';
import RecordListPending from './Components/Transport Admin/Pendingjobs';
import LoginFormTransportAdmin from './Components/Transport Admin/TransportAdmin';
import LogisticsAdminHomepage from './Components/Transport Admin/TransportAdmin Porta.';
import DealerRecordListPending from './Components/Transport Account/Pending';
import RecordListActive from './Components/Transport Admin/ActiveJobs';
import RecordListCompleted from './Components/Transport Admin/Completed';
import RegisteredClientsTable from './Components/Transport Admin/CustomerList';
import CustomerDetailsWithJobs from './Components/Transport Admin/CustomerDetailsiwthjobs';
import RecordDetails from './Components/Transport Admin/RecordDetails';
import RecordListActiveClient from './Components/Transport Account/ClientActiveJobs';
import ForgotPassword from './Components/Transport Account/Forget-password';
import ResetPassword from './Components/Transport Account/Reset-Password';
import UserDetails from './Components/Transport Account/Edit Account';
import RegisteredClientsOnlyTable from './Components/Transport Admin/RegisteredClientsOnly';
import Sidenav from './Components/Navbar/SideBar';
import DealerFooter from './Components/Footer/DealerFooter';
import SidebarAdmin from './Components/Navbar/SideBarAdmin';
import { useLocation, matchPath } from "react-router-dom";
import RecordListCompletedClient from './Components/Transport Account/Completedjobs';
import RecordForm from './Components/Transport Admin/JobForm';
import RecordFormActive from './Components/Transport Admin/JobFormActivate';
import RecordEditFormActive from './Components/Transport Admin/JobFormEditActive';
import DealerReviewForm from './Components/Transport Account/ReviewDealer';
import DealerRecordDetails from './Components/Transport Account/RecordDetailsDealer';
import CompletedJobDetails from './Components/Transport Account/CompletedJobDetails';
import CompletedForm from './Components/Transport Account/JobFormCompleted';
import RecordFormPending from './Components/Transport Account/RecordFormPending';
import RecordDetailsActive from './Components/Transport Admin/RecordDetailsActive';
import DealerRecordDetailsActive from './Components/Transport Account/ActiveJobDetails';
import ReviewFormWithID from './Components/Transport Account/ReviewForm';
import RolesManagement from './Components/Transport Admin/AddRoles';
import ResponsibilitiesManagement from './Components/Transport Admin/Responsibilites';
import LogisticsTiming from './Components/Transport Admin/LogisticsTiming';
import DeleteMoveReviews from './Components/Reviews/DeleteMoveReviews';
import RecordListPendingPerClient from './Components/Transport Admin/PendingjobsPerClient';
import RecordListActivePerClient from './Components/Transport Admin/ActiveJobsPerclient';
import RecordDetailsCompleted from './Components/Transport Admin/RecordDetailsCompleted';
import RecordFormCompleted from './Components/Transport Admin/RecordFormCompleted';
import DealerActiveRecordDetails from './Components/Transport Account/ActiveJobDetails';
import RecordFormActiveClient from './Components/Transport Account/RecordFormActive';
import EmailManagerLogisitcs from './Components/Transport Admin/EmailChange';
import LogisticsLocation from './Components/Transport Admin/LocationLogistics';
import LogisticsContactEditor from './Components/Transport Admin/ContactLogistics';
import AdminWhatWeDo from './Components/Transport Admin/Whatwedo';
import DriverNavbar from './Components/Navbar/DriverNavbar';
import WatchVideo from './Components/Move/VideoDriver';
import EmailForm from './Components/Transport Admin/DriverEmail';
import ImageAdjuster from './Components/Admin/Logosupload';
function App() {

  const moveRoutes = [
    "/move",
    "/subcontractform",
    "/DriveDetail",
    "/",
    "/LogisticContact",
    "/services",
  ]; // Routes for MoveFooter
  const adminroutes = [
    "/Admin/AdminPortal",
    "/Admin/AdminPortal/Addmake",
    "/Admin/AdminPortal/Contact",
    "/Admin/AdminPortal/AddAchievement",
    "/Admin/AdminPortal/AddModel",
    "/Admin/AdminPortal/AddAdmin",
    "/Admin/AdminPortal/CarReview",
    "/Admin/AdminPortal/email",
    "/Admin/AdminPortal/DeleteFeatures",
    "/Admin/AdminPortal/AddCar",
    "/Admin/AdminPortal/Location",
    "/Admin/AdminPortal/ListCar",
    "/Admin/AdminPortal/DeleteReviews",
    "/Admin/AdminPortal/DeleteCar",
    "/Admin/AdminPortal/AddMoveFeatures",
    "/Admin/AdminPortal/AddWhyus",
    "/Admin/AdminPortal/ChangeWeather",
    "/Admin/AdminPortal/Inventory/Edit/:id",
    
    "/Admin/AdminPortal/Timings",
    "/Admin/AdminPortal/Aboutus",
  ];
  const dealerroute = [
    "/Companies/Home",
    "/Companies/Subcontract",
    "/Companies/Pending",
    "/Companies/Pending/record-details/:jobId",
    "/Companies/Pending/record-details/:jobId/Form",
    "/Companies/ActiveJobs",
    "/Companies/Active/record-details/:jobId",
    "/Companies/Edit",
    "/Companies/Completed",
    "/Companies/Completed/record-details/:jobId",
    "/Companies/Completed/record-details/:jobId/Form",
    "/Companies/Completed/Review",
    "/Companies/Active/record-details/:jobId/Form",
    "/Companies/Completed/record-details/:jobId/Review"
  ];
  const transadminroute = [
    "/Logistics/AdminPortal/Pending",
    "/Logistics/AdminPortal/Edit",
    "/Logistics/Admin/AdminPortal",
    "/Logistics/AdminPortal/Active",
    "/Logistics/AdminPortal/Completed",
    "/Logistics/AdminPortal/Completed/record-details/:jobId",
    "/Logistics/AdminPortal/Logos",
    "/Logistics/AdminPortal/Active/record-details/:jobId",
    "/Logistics/AdminPortal/Active/record-details/:jobId/Form",
    "/Logistics/AdminPortal/Pending/record-details/:jobId/ActivationForm",
    "/Logistics/AdminPortal/Active/record-details/:jobId/EditForm",
    "/Logistics/AdminPortal/Customers",
    "/Logistics/AdminPortal/Roles",
    "/Logistics/AdminPortal/Email",
    "/Logistics/AdminPortal/WhatWedo",
    "/Logistics/AdminPortal/Customerjobs",
    "/Logistics/AdminPortal/RegisteredCustomers",
    "/Logistics/AdminPortal/Customers/:customerId",
    "/Logistics/AdminPortal/Pending/record-details/:jobId",
    "/Logistics/AdminPortal/Pending/record-details/:jobId/Form",
    "/Logistics/AdminPortal/Responsibilities",
    "/Logistics/AdminPortal/DriverEmail",
    "/Logistics/AdminPortal/Time",
    "/Logistics/AdminPortal/Contact",
    "/Logistics/AdminPortal/Location",
    "/Logistics/AdminPortal/Feedback",
    "/Logistics/AdminPortal/Customers/:customerId/PendingJobs",
    "/Logistics/AdminPortal/Customers/:customerId/ActiveJobs",
    "/Logistics/AdminPortal/Services"
  ];
  
  const ConditionalNavbar = () => {
    const location = useLocation(); // Get the current route
  
    // Helper function to match dynamic routes
    const matchesRoute = (routes) =>
      routes.some((route) => matchPath(route, location.pathname));
  
    const isadminnavbar = matchesRoute(adminroutes);
    const isMoveNavbar = matchesRoute(moveRoutes); // Check if current route needs MoveNavbar
    const isdealernavbar = matchesRoute(dealerroute);
    const istranadmin = matchesRoute(transadminroute);
    
    if (isadminnavbar) {
      return <AdminNavbar />;
    } 
    else if (location.pathname==="/watch-video") {
      return <DriverNavbar />;
    }
    
    else if (isMoveNavbar) {
      return <MoveNavbar />;
    } else if (location.pathname==="/Admin"|| location.pathname==="/Logistics/Signup"||location.pathname==="/Logistics/Login"||location.pathname==="/Logistics/Admin"||location.pathname==="/Logistics/Login/Forget-password"|| location.pathname.includes("/reset-password/")){
      // Handle these routes specifically if needed
    } else if (isdealernavbar) {
      return <Sidenav />;
    } else if (istranadmin) {
      
      return <SidebarAdmin />;
    } else {
      return <NavbarComponent />;
    }
  };

const ConditionalFooter = () => {
  const location = useLocation(); // Get the current route
  
  const isMoveFooter = moveRoutes.includes(location.pathname)||transadminroute.includes(location.pathname); // Check if current route needs MoveFooter
  const isadminfooter= adminroutes.includes(location.pathname);
  const isdealernavbar=dealerroute.includes(location.pathname);
  if (isMoveFooter){
    return <MoveFooter/>;
  }
  else if (isadminfooter){
    return <AdminFooter/>;
  }
  else if (location.pathname==="/Admin"|| location.pathname==="/Logistics/Signup"||location.pathname==="/Logistics/Login"||location.pathname==="/Logistics/Admin"||location.pathname==="/Logistics/Login/Forget-password"||location.pathname.includes("/reset-password/")){

  }
  else if (isdealernavbar){
    
  }
else{
return <Footer/>;
}
  
};
  return (
    <>
      <title>Zoom Autos</title>
      <Router>
      <CarFilterProvider>
        <AddressProvider>
          <AdminProvider>
          <DealerProvider>
          <ConditionalNavbar /> {/* Dynamically display navbar based on route */}
          
            <TransportAdminProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/CarSale" element={<HomePage />} />
            <Route path="/SellYourCar" element={<SellYourVehicleForm />} />
            <Route path="/Inventory" element={<CarList />} />
            <Route path="/Termsandconditions" element={<TermsAndConditionspage />} />
            <Route path="/" element={<MoveHomePage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/subcontractform" element={<ContactFormMovex />} />
            <Route path="/Inventory/:id" element={<CarDetails />} />
            <Route path="/ContactUs" element={<ContactUS />} />
            <Route path="/Admin" element={<SignUpForm />} />
            <Route path="/Logistics/Signup" element={<SignupPage />} />
            <Route path="/Logistics/Login" element={<LoginPage />} />
            
            <Route path="/Logistics/Login/Forget-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/DriveDetail" element={<UserInformationForm/>} />
            <Route path="/LogisticContact" element={<MoveContactUs/>} />
            <Route path="/Logistics/Admin" element={<LoginFormTransportAdmin/>} />
            <Route path="/watch-video" element={<WatchVideo/>} />
            
            
            
            {/* Use ProtectedRoute for admin routes */}
            <Route
              path="/Admin/AdminPortal"
              element={<ProtectedRoute element={<AdminPortal />} />}
            />
            <Route
              path="/Admin/AdminPortal/Addmake"
              element={<ProtectedRoute element={<AddMakeForm />} />}
            />
<Route
              path="/Admin/AdminPortal/CarReview/Inventory/:id"
              element={<ProtectedRoute element={<CarDetailsAdmin />} />}
            />

<Route
              path="/Admin/AdminPortal/Inventory/Edit/:id"
              element={<ProtectedRoute element={<CarEditForm />} />}
            />
            <Route
              path="/Admin/AdminPortal/AddCar"
              element={<ProtectedRoute element={<ListYourVehicleForm />} />}
            />
            <Route
              path="/Admin/AdminPortal/AddModel"
              element={<ProtectedRoute element={<AddModelAndVariant />} />}
            />
            <Route
              path="/Admin/AdminPortal/AddAdmin"
              element={<ProtectedRoute element={<AdminAdd />} />}
            />
            <Route
              path="/Admin/AdminPortal/DeleteFeatures"
              element={<ProtectedRoute element={<DeleteWhyUsCards />} />}
            />
            <Route
              path=
            "/Admin/AdminPortal/email"
            element={<ProtectedRoute element={<EmailManager />} />}
            />
            <Route
              path="/Admin/AdminPortal/DeleteCar"
              element={<ProtectedRoute element={<DelCarList />} />}
            />
            <Route
              path="/Admin/AdminPortal/Timings"
              element={<ProtectedRoute element={<Timing/>} />}
            />
            <Route path="/Admin/AdminPortal/Inventory/Edit/:id" 
            element={<ProtectedRoute element={<CarEditForm/>} />} />

            <Route
              path="/Admin/AdminPortal/AddMoveFeatures"
              element={<ProtectedRoute element={<ServiceForm />} />}
            />
            <Route
              path="/Admin/AdminPortal/AddWhyus"
              element={<ProtectedRoute element={<WhyusForm />} />}
            />
                        <Route
              path="/Admin/AdminPortal/CarReview"
              element={<ProtectedRoute element={<CarListReview />} />}
            />
                  <Route
              path="/Admin/AdminPortal/DeleteReviews"
              element={<ProtectedRoute element={<DeleteReview />} />}
            />
                <Route
              path="/Admin/AdminPortal/Contact"
              element={<ProtectedRoute element={<ContactEditor />} />}
            />
            <Route
              path="/Admin/AdminPortal/Aboutus"
              element={<ProtectedRoute element={<AboutUsAdmin />} />}
            />
            <Route
              path="/Admin/AdminPortal/Location"
              element={<ProtectedRoute element={<GoogleLocationManager />} />}
            />
            
            <Route
              path="/Logistics/AdminPortal/Customers/:customerId/ActiveJobs"
              element={<TransportProtectedRoute element={<RecordListActivePerClient />} />}
            />
            <Route
              path="/Logistics/AdminPortal/Customers/:customerId/CompletedJobs"
              element={<TransportProtectedRoute element={<RecordListActivePerClient />} />}
            />
            <Route
              path="/Companies/Home"
              element={<DealerProtectedRoute element={<LogisticsHomepage />}/>}
            />
            <Route
              path="/Companies/Subcontract"
              element={<DealerProtectedRoute element={<RegisteredContactFormMovex/>}/>}
            />
                   
            <Route
              path="/Companies/Completed"
              element={<DealerProtectedRoute element={<RecordListCompletedClient/>}/>}
            />
            <Route
              path="/Companies/Completed/Review"
              element={<DealerProtectedRoute element={<ReviewFormWithID/>}/>}
            />
            <Route
              path="/Companies/Pending"
              element={<DealerProtectedRoute element={<DealerRecordListPending/>}/>}
            />
                        <Route
              path="/Companies/Pending/record-details/:jobId"
              element={<DealerProtectedRoute element={<DealerRecordDetails/>}/>}
            />
                      <Route
              path="/Companies/Pending/record-details/:jobId/Form"
              element={<DealerProtectedRoute element={<RecordFormPending/>}/>}
            />
            <Route
              path="/Companies/ActiveJobs"
              element={<DealerProtectedRoute element={<RecordListActiveClient/>}/>}
            />
                        <Route
              path="/Companies/Active/record-details/:jobId"
              element={<DealerProtectedRoute element={<DealerActiveRecordDetails/>}/>}
            />
                      <Route
              path="/Companies/Active/record-details/:jobId/Form"
              element={<DealerProtectedRoute element={<RecordFormActiveClient/>}/>}
            />
                            <Route
              path="/Companies/Completed/record-details/:jobId"
              element={<DealerProtectedRoute element={<CompletedJobDetails/>}/>}
            />
                <Route
              path="/Companies/Completed/record-details/:jobId/Form"
              element={<DealerProtectedRoute element={<CompletedForm/>}/>}
            />
              <Route
              path="/Companies/Completed/record-details/:jobId/Review"
              element={<DealerProtectedRoute element={<DealerReviewForm/>}/>}
            />
            
                        <Route
              path="/Companies/Edit"
              element={<DealerProtectedRoute element={<UserDetails/>}/>}
            />
            
            
                        <Route
              path="/Logistics/AdminPortal/Pending"
              element={<TransportProtectedRoute element={<RecordListPending/>}/>}
            />
            
            <Route
              path="/Logistics/AdminPortal/Edit"
              element={<TransportProtectedRoute element={<UserDetails/>}/>}
            />
            <Route
              path="/Logistics/Admin/AdminPortal"
              element={<TransportProtectedRoute element={<LogisticsAdminHomepage/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Active"
              element={<TransportProtectedRoute element={<RecordListActive/>}/>}
            /> 
            <Route
              path="/Logistics/AdminPortal/Roles"
              element={<TransportProtectedRoute element={<RolesManagement/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Active/record-details/:jobId"
              element={<TransportProtectedRoute element={<RecordDetailsActive/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Customerjobs"
              element={<TransportProtectedRoute element={<CustomerDetailsWithJobs/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Responsibilities"
              element={<TransportProtectedRoute element={<ResponsibilitiesManagement/>}/>}
              />
              <Route
              path="/Logistics/AdminPortal/Logos"
              element={<TransportProtectedRoute element={<ImageAdjuster />} />}
            />
            <Route
              path="/Logistics/AdminPortal/Location"
              element={<TransportProtectedRoute element={<LogisticsLocation/>}/>}
              />
            <Route
              path=  "/Logistics/AdminPortal/Contact"
              element={<TransportProtectedRoute element={<LogisticsContactEditor/>}/>}
              />
              <Route
              path="/Logistics/AdminPortal/Active/record-details/:jobId/EditForm"
              element={<TransportProtectedRoute element={<RecordEditFormActive/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Services"
              element={<TransportProtectedRoute element={<ServiceForm />} />}
            />
            <Route
              path="/Logistics/AdminPortal/DriverEmail"
              element={<TransportProtectedRoute element={<EmailForm />} />}
            />
            
            <Route
              path="/Logistics/AdminPortal/Active/record-details/:jobId/Form"
              element={<TransportProtectedRoute element={<RecordForm/>}/>}
              />
             
               <Route
              path="/Logistics/AdminPortal/Pending/record-details/:jobId"
              element={<TransportProtectedRoute element={<RecordDetails/>}/>}
              />
                             <Route
              path="/Logistics/AdminPortal/Completed/record-details/:jobId/Form"
              element={<TransportProtectedRoute element={<RecordFormCompleted/>}/>}
              />
              
                           <Route
              path="/Logistics/AdminPortal/Pending/record-details/:jobId/ActivationForm"
              element={<TransportProtectedRoute element={<RecordFormActive/>}/>}
              />
                      <Route
              path="/Logistics/AdminPortal/Time"
              element={<TransportProtectedRoute element={<LogisticsTiming/>}/>}
              />
                    <Route
              path="/Logistics/AdminPortal/Email"
              element={<TransportProtectedRoute element={<EmailManagerLogisitcs/>}/>}
              />
                    <Route
              path="/Logistics/AdminPortal/Feedback"
              element={<TransportProtectedRoute element={<DeleteMoveReviews/>}/>}
              />
            <Route
              path="/Logistics/AdminPortal/Completed"
              element={<TransportProtectedRoute element={<RecordListCompleted/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Completed/record-details/:jobId"
              element={<TransportProtectedRoute element={<RecordDetailsCompleted/>}/>}
              />
              <Route
              path="/Logistics/AdminPortal/Completed/record-details/${jobId}/Form"
              element={<TransportProtectedRoute element={<RecordForm/>}/>}
              />
            <Route
              path="/Logistics/AdminPortal/Customers"
              element={<TransportProtectedRoute element={<RegisteredClientsTable/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/RegisteredCustomers"
              element={<TransportProtectedRoute element={<RegisteredClientsOnlyTable/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Customers/:customerId"
              element={<TransportProtectedRoute element={<CustomerDetailsWithJobs/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/WhatWedo"
              element={<TransportProtectedRoute element={<AdminWhatWeDo/>}/>}
            />
            <Route
              path="/Logistics/AdminPortal/Customers/:customerId/PendingJobs"
              element={<TransportProtectedRoute element={<RecordListPendingPerClient/>}/>}
            />
          </Routes>
          <ConditionalFooter /> {/* Dynamically display footer based on route */}
          </TransportAdminProvider>
          </DealerProvider>
          </AdminProvider>
        </AddressProvider>
        
      </CarFilterProvider>
    </Router>
    </>
  );
}

export default App;
